import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './shared/hooks/useAuth';
import { GroupProvider } from './shared/hooks/useGroup';
import AppRoutes from './app/routes/AppRoutes';

function App() {
  return (
    <Router>
      <AuthProvider>
        <GroupProvider>
          <div className="App">
            {/* Main app content will be rendered here */}
            <div className="min-h-screen bg-neutral-50">
              <header className="bg-neutral-100 shadow">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                  <div className="flex justify-between items-center py-6">
                    <h1 className="text-3xl font-bold tracking-tight"><span className="text-neutral-900">Esu</span><span className="text-primary-500">Sol</span></h1>
                    <p className="hidden sm:block text-neutral-600">Savings circle operations — built for esusu, ajo, and sol communities</p>
                  </div>
                </div>
              </header>
              
              <main>
                <AppRoutes />
              </main>
            </div>
          </div>
        </GroupProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
